import { r } from '../../theme/tokens';
import type { SxProps, Theme } from '@mui/material/styles';

export const getChartTooltipSx = (theme: Theme): SxProps<Theme> => ({
  backgroundColor: 'transparent !important',
  border: '0 !important',
  boxShadow: 'none !important',
  padding: '0 !important',
  '&.MuiChartsTooltip-paper, & .MuiChartsTooltip-paper': {
    backgroundColor: theme.app.colors.surface,
    border: `1px solid ${theme.app.colors.border}`,
    color: theme.app.colors.text,
    borderRadius: r('md'),
    boxShadow: 'none',
    paddingTop: '6px !important',
    paddingBottom: '4px !important',
    paddingLeft: '4px !important',
    paddingRight: '4px !important',
  },
  color: theme.app.colors.text,
  fontSize: theme.typography.body2.fontSize,
  lineHeight: theme.typography.body2.lineHeight,
  fontWeight: theme.typography.fontWeightRegular,
  '& .MuiTypography-root, & .MuiChartsTooltip-cell, & .MuiChartsTooltip-labelCell, & .MuiChartsTooltip-valueCell, & .MuiChartsTooltip-axisValueCell, & caption, & td, & th':
    {
      color: theme.app.colors.text,
      fontSize: theme.typography.body2.fontSize,
      lineHeight: theme.typography.body2.lineHeight,
      fontWeight: theme.typography.fontWeightRegular,
    },
  '& .MuiChartsTooltip-table, & table': {
    borderCollapse: 'separate',
    borderSpacing: 0,
    border: '0 !important',
    width: 'auto !important',
    tableLayout: 'auto',
  },
  '& .MuiChartsTooltip-table caption, & caption': {
    borderBottom: `1px solid ${theme.app.colors.border} !important`,
    paddingTop: '0 !important',
    paddingBottom: '6px !important',
    paddingLeft: '4px !important',
    paddingRight: '4px !important',
    textAlign: 'left',
    lineHeight: 1.05,
  },
  '& .MuiChartsTooltip-table > tbody > tr > th, & .MuiChartsTooltip-table > tbody > tr > td, & tbody > tr > th, & tbody > tr > td':
    {
      border: '0 !important',
      paddingLeft: '6px !important',
      paddingRight: '6px !important',
      paddingTop: '4px !important',
      paddingBottom: '4px !important',
      verticalAlign: 'middle !important',
    },
  '& .MuiChartsTooltip-table > tbody > tr:first-of-type > th, & .MuiChartsTooltip-table > tbody > tr:first-of-type > td, & tbody > tr:first-of-type > th, & tbody > tr:first-of-type > td':
    {
      paddingTop: '10px !important',
    },
  '& .MuiChartsTooltip-table > tbody > tr:last-of-type > th, & .MuiChartsTooltip-table > tbody > tr:last-of-type > td, & tbody > tr:last-of-type > th, & tbody > tr:last-of-type > td':
    {
      paddingBottom: '6px !important',
    },
  '& .MuiChartsTooltip-labelCell': {
    textAlign: 'left !important',
  },
  '& .MuiChartsTooltip-valueCell': {
    textAlign: 'right !important',
    whiteSpace: 'nowrap',
    fontVariantNumeric: 'tabular-nums',
  },
  '& .MuiChartsTooltip-markContainer': {
    width: '16px !important',
    display: 'inline-flex !important',
    alignItems: 'center !important',
    verticalAlign: 'middle !important',
  },
  '& .MuiChartsTooltip-mark': {
    width: '8px !important',
    height: '8px !important',
    borderRadius: '2px !important',
    marginTop: '0 !important',
    marginBottom: '0 !important',
  },
});
